import R from 'ramda';

const getCardoConfig = ({ baseBreakpointConfig = {}, nthBreakpointConfig = {} }) =>
  ({
    breakpointConfig: {
      ...(
        (baseBreakpointConfig.xsmall || nthBreakpointConfig.xsmall) && {
          xsmall: R.mergeDeepRight(
            R.defaultTo({}, baseBreakpointConfig.xsmall),
            R.defaultTo({}, nthBreakpointConfig.xsmall),
          ),
        }
      ),
      ...(
        (baseBreakpointConfig.small || nthBreakpointConfig.small) && {
          small: R.mergeDeepRight(
            R.defaultTo({}, baseBreakpointConfig.small),
            R.defaultTo({}, nthBreakpointConfig.small),
          ),
        }
      ),
      ...(
        (baseBreakpointConfig.medium || nthBreakpointConfig.medium) && {
          medium: R.mergeDeepRight(
            R.defaultTo({}, baseBreakpointConfig.medium),
            R.defaultTo({}, nthBreakpointConfig.medium),
          ),
        }
      ),
      ...(
        (baseBreakpointConfig.large || nthBreakpointConfig.large) && {
          large: R.mergeDeepRight(
            R.defaultTo({}, baseBreakpointConfig.large),
            R.defaultTo({}, nthBreakpointConfig.large),
          ),
        }
      ),
      ...(
        (baseBreakpointConfig.xlarge || nthBreakpointConfig.xlarge) && {
          xlarge: R.mergeDeepRight(
            R.defaultTo({}, baseBreakpointConfig.xlarge),
            R.defaultTo({}, nthBreakpointConfig.xlarge),
          ),
        }
      ),
    },
  });

export { getCardoConfig };
